import { eventHasRun } from '../../utils/eventTracker';

export const DDC_LINK_SOCIALSHARE = 'ddc.link.socialShare';

function share({ currentTarget: element, timeStamp }) {
	let eventObject;

	if (
		!eventHasRun(DDC_LINK_SOCIALSHARE, {
			timeStamp
		})
	) {
		eventObject = {
			eventType: DDC_LINK_SOCIALSHARE,
			eventData: {
				service: element.getAttribute('title'),
				url: element.getAttribute('href'),
				element
			}
		};
	}

	return eventObject;
}

export default share;
